"use client";

import { BSRInformation } from "./bsr/BSRInformation";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Information as LegacyInformation } from "./legacy/Information";

export const Information = createBSRExperimentIcon(
  LegacyInformation,
  BSRInformation
);
